import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect } from 'react';
import { Row, Container, Col } from 'react-bootstrap';
import Wrapper from '../wrapper/Wrapper';
import ContentTileWrapper from '../content/ContentTileWrapper';
import { useQueryParams, NumberParam } from 'use-query-params';
import { articleDuck } from '../../ducks/article';
import { Formik } from "formik";
import FilterAccordionSelect from "../accordion/AccordionFilterSelect";
import { PageCounter } from "./PageCounter";
import Heading from '../heading/Heading';

var moment = require('moment');

var ArticleList = function ArticleList(props) {
  var _props$rendering;

  var _useQueryParams = useQueryParams({
    page: NumberParam
  }),
      _useQueryParams2 = _slicedToArray(_useQueryParams, 2),
      _useQueryParams2$ = _useQueryParams2[0],
      page = _useQueryParams2$.page,
      year = _useQueryParams2$.year,
      setQuery = _useQueryParams2[1];

  var total = props.total,
      currentPage = props.currentPage,
      articleResults = props.articleResults,
      getArticles = props.getArticles,
      setDataSource = props.setDataSource,
      setPageSize = props.setPageSize,
      _props$facets = props.facets,
      facets = _props$facets === void 0 ? [] : _props$facets,
      _props$isSearch = props.isSearch,
      isSearch = _props$isSearch === void 0 ? false : _props$isSearch;
  var dataSource = (_props$rendering = props.rendering) === null || _props$rendering === void 0 ? void 0 : _props$rendering.dataSource;

  var _ref = props.fields || {},
      _ref$Background = _ref.Background,
      Background = _ref$Background === void 0 ? {} : _ref$Background,
      _ref$Padding = _ref.Padding,
      Padding = _ref$Padding === void 0 ? {} : _ref$Padding,
      _ref$Margin = _ref.Margin,
      Margin = _ref$Margin === void 0 ? {} : _ref$Margin,
      FilterByYear = _ref.FilterByYear,
      _ref$Count = _ref.Count,
      Count = _ref$Count === void 0 ? {} : _ref$Count,
      _ref$Button = _ref.Button,
      Button = _ref$Button === void 0 ? {} : _ref$Button,
      title = _ref.title,
      modelTag = _ref.titleTag;

  var tag = (modelTag === null || modelTag === void 0 ? void 0 : modelTag.value) || "";
  var layout = {
    background: Background.value,
    padding: Padding.value,
    margin: Margin.value
  };
  var titleTag = (tag === null || tag === void 0 ? void 0 : tag.replace('h', '')) || 2;

  var getReduxArticles = function getReduxArticles(newPage) {
    setQuery({
      page: newPage
    });
    getArticles(newPage, FilterByYear ? year : undefined);
  };

  useEffect(function () {
    if (!isSearch) {
      setPageSize(Count.value || 10);
      setDataSource(dataSource);
    }
  }, []);
  useEffect(function () {
    var addthis = window.addthis || {
      layers: {
        refresh: function refresh() {
          return "";
        }
      }
    };
    addthis.layers.refresh();
  }, articleResults);

  var makeModel = function makeModel(model) {
    var PublishedDate = model.PublishedDate ? moment(model.PublishedDate).format('MM/DD/yyyy') : "";
    return {
      title: {
        value: model.Title
      },
      subtitle: {
        value: PublishedDate
      },
      text: {
        value: model.Summary
      },
      image: {
        value: {
          src: model.ImageSrc,
          alt: model.ImageAlt
        }
      },
      ctaLink: {
        "value": {
          "href": model.PageUrl,
          // "class":"",
          "text": "read more"
        }
      },
      linkType: "link",
      articleImage: true
    };
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, Boolean(title === null || title === void 0 ? void 0 : title.value) && /*#__PURE__*/React.createElement(Col, {
    lg: "12"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: titleTag.value,
    field: title,
    className: "cb-content-block__title cb-color-red-900"
  })), /*#__PURE__*/React.createElement(Col, null, Boolean(facets.length) && /*#__PURE__*/React.createElement(FilterYear, _extends({}, props, {
    facets: facets[0].Values
  })), articleResults.map(function (article, index) {
    var model = makeModel(article);
    return /*#__PURE__*/React.createElement("div", {
      className: "cb-article-list",
      key: "article" + index
    }, /*#__PURE__*/React.createElement(ContentTileWrapper, {
      model: model,
      layout: {
        type: "list"
      },
      alignment: "left",
      isArticle: true,
      isSearch: isSearch,
      className: "cb-content-block__article",
      isNotLast: index !== articleResults.length - 1,
      key: index
    }));
  }), !isSearch && Boolean(articleResults.length) && /*#__PURE__*/React.createElement(PageCounter, {
    totalPages: Math.round(total / articleResults.length),
    currentPage: page - 1 || 0,
    handleChange: function handleChange(e) {
      return getReduxArticles(e + 1);
    }
  })))));
};

export var FilterYear = function FilterYear(props) {
  var _useQueryParams3 = useQueryParams({
    page: NumberParam,
    year: NumberParam
  }),
      _useQueryParams4 = _slicedToArray(_useQueryParams3, 2),
      year = _useQueryParams4[0].year,
      setQuery = _useQueryParams4[1];

  var setYear = props.setYear,
      _props$facets2 = props.facets,
      facets = _props$facets2 === void 0 ? [] : _props$facets2; // console.log(facets, "FACETS")

  var items = facets.map(function (value) {
    return {
      "name": value.Name,
      "displayName": value.Name,
      "fields": {}
    };
  });

  var updateYear = function updateYear(newYear) {
    setQuery({
      year: newYear,
      page: 1
    });
    setYear(newYear);
  };

  var _props$fields = props.fields,
      _props$fields$Backgro = _props$fields.Background,
      Background = _props$fields$Backgro === void 0 ? {} : _props$fields$Backgro,
      _props$fields$Padding = _props$fields.Padding,
      Padding = _props$fields$Padding === void 0 ? {} : _props$fields$Padding,
      _props$fields$Margin = _props$fields.Margin,
      Margin = _props$fields$Margin === void 0 ? {} : _props$fields$Margin;
  var layout = {
    background: Background.value,
    padding: Padding.value,
    margin: Margin.value
  };
  var CategoryMap = items.map(function (category) {
    return {
      label: category.displayName,
      value: category.name,
      id: category.id
    };
  });
  var CategoryArray = [{
    value: "recent",
    label: "Recent"
  }].concat(_toConsumableArray(CategoryMap));

  var changeHandler = function changeHandler(e) {
    e.persist();
    var newYear = e.target.value === "recent" ? undefined : e.target.value;
    updateYear(newYear);
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    className: "cb-article-list__year-filter"
  }, /*#__PURE__*/React.createElement(Col, {
    className: "label"
  }, /*#__PURE__*/React.createElement("span", null, "Filter by year:")), /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      faqFilter: year || "recent"
    },
    enableReinitialize: true
  }, function (props) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(FilterAccordionSelect, {
      categories: CategoryArray,
      controlled: true,
      value: year,
      changeHandler: changeHandler
    })));
  }))));
};
export default ArticleList;